/* VECHEN — defensive recovery for any Horizon details-based scroll lock.
 * The mobile header menu no longer uses details[scroll-lock], but this remains
 * as a last-resort guard for other theme drawers/details and third-party code.
 */
/* ------------------------------------------------------------------
   VECHEN — scroll-lock watchdog

   Horizon locks page scrolling by putting a `scroll-lock` attribute on <html>,
   which applies `overflow: hidden`. The lock is applied by a document-level
   listener reacting to the native `toggle` event of any `<details scroll-lock>`
   element, but the panel a shopper can actually see is drawn by that component's
   own open path. Those are two different code paths off one tap, and on Android
   a tap landing while the page is still moving under momentum can fire the first
   without the second.

   The result is a page pinned at whatever scroll offset it had reached, with the
   header scrolled out of reach above it and no visible drawer to close. It reads
   as the site freezing.

   This watchdog checks, shortly after any lock is applied, that something on
   screen actually owns it. If nothing does, it closes the stranded element
   through the theme's own path so the lock is released cleanly.
   ------------------------------------------------------------------ */
(function () {
  // Flip to true to show a live badge in the corner reporting what is holding
  // the scroll lock. Screenshot it while the page is frozen and the cause is
  // named on screen. Set back to false before going live.
  var VECHEN_SCROLL_LOCK_DEBUG = false;

  var SETTLE_MS = 600;
  var auditTimer;

  function isGenuinelyVisible(element) {
    if (!element) return false;
    var rect = element.getBoundingClientRect();
    if (rect.width < 2 || rect.height < 2) return false;
    if (rect.bottom < 0 || rect.top > window.innerHeight) return false;
    var styles = window.getComputedStyle(element);
    if (styles.visibility === 'hidden' || styles.display === 'none') return false;
    if (parseFloat(styles.opacity) < 0.05) return false;
    return true;
  }

  function ownerIsOnScreen(details) {
    if (details.classList.contains('menu-open')) return true;
    var panel = details.querySelector(':scope > :not(summary)');
    return isGenuinelyVisible(panel);
  }

  function audit() {
    if (!document.documentElement.hasAttribute('scroll-lock')) return;

    // A genuinely open modal dialog owns the lock legitimately.
    if (document.querySelector('dialog[open], header-drawer .menu-drawer-container[open].menu-open')) return;

    var stranded = [];
    var somethingVisible = false;

    document.querySelectorAll('details[scroll-lock][open]').forEach(function (details) {
      if (ownerIsOnScreen(details)) {
        somethingVisible = true;
      } else {
        stranded.push(details);
      }
    });

    if (somethingVisible) return;

    // Close through the element itself so the theme's own `toggle` handler runs
    // unlockScroll and keeps its owner bookkeeping in step.
    stranded.forEach(function (details) {
      details.open = false;
    });

    // Belt and braces: if the attribute survived, the page still cannot scroll.
    if (document.documentElement.hasAttribute('scroll-lock') && !document.querySelector('dialog[open]')) {
      var stillOpen = document.querySelector('details[scroll-lock][open]');
      if (!stillOpen) document.documentElement.removeAttribute('scroll-lock');
    }
  }

  function describe(element) {
    if (!element) return 'none';
    var id = element.id ? '#' + element.id : '';
    var cls = element.className ? '.' + String(element.className).trim().split(/\s+/).join('.') : '';
    return element.tagName.toLowerCase() + id + cls;
  }

  var badge;
  function renderBadge() {
    if (!VECHEN_SCROLL_LOCK_DEBUG) return;
    if (!badge) {
      badge = document.createElement('div');
      badge.setAttribute('style', [
        'position:fixed', 'left:0', 'right:0', 'bottom:0', 'z-index:2147483647',
        'background:#0A0A10', 'color:#fff', 'font:11px/1.35 monospace',
        'padding:8px 10px', 'pointer-events:none', 'white-space:pre-wrap',
      ].join(';'));
      document.body.appendChild(badge);
    }
    var locked = document.documentElement.hasAttribute('scroll-lock');
    var openDialog = document.querySelector('dialog[open]');
    var openDetails = [];
    document.querySelectorAll('details[scroll-lock][open]').forEach(function (d) {
      openDetails.push(describe(d) + (ownerIsOnScreen(d) ? ' [visible]' : ' [NOT VISIBLE]'));
    });
    badge.textContent =
      'scroll-lock: ' + (locked ? 'ON' : 'off') +
      '\nscrollY: ' + Math.round(window.scrollY) +
      '\ndialog[open]: ' + describe(openDialog) +
      '\ndetails[scroll-lock][open]: ' + (openDetails.length ? openDetails.join(' | ') : 'none');
  }

  function scheduleAudit() {
    clearTimeout(auditTimer);
    auditTimer = setTimeout(function () {
      audit();
      renderBadge();
    }, SETTLE_MS);
  }

  if (VECHEN_SCROLL_LOCK_DEBUG) {
    document.addEventListener('DOMContentLoaded', renderBadge);
    setInterval(renderBadge, 500);
  }

  new MutationObserver(scheduleAudit).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['scroll-lock'],
  });

  window.addEventListener('pageshow', scheduleAudit);
  window.addEventListener('orientationchange', scheduleAudit);
})();
